import React from 'react';

const AppWrapper = ({image,title,children}) => (
	<div className="row">                       
        <div className="col-sm-8 offset-sm-2">
            <div className="panel" style={{border: "1px solid #e4eaec"}}>
                <div className="panel-heading">
                    <h3 style={{padding:0,paddingTop:'20px'}} className="panel-title text-center">
                    	<img style={{maxHeight:'80px',maxWidth:'40%'}} src={image} />
                    </h3>
                    <hr style={{width:'90%'}} />
                </div>
                <div className="panel-body">
             		<div className="offset-sm-2 col-sm-8">
             			{children}
             		</div>
                </div>
            </div>
        </div>
    </div>
);

export default AppWrapper;





// WEBPACK FOOTER //
// ./containers/apps/AppWrapper.js